// a class that handles the websocket connection using rxjs websockets

import { webSocket } from 'rxjs/webSocket';
import {  share, tap } from 'rxjs/operators';
import { retry } from 'rxjs';

export default class WebSocketConnection {
//todo: this should be a config file
  constructor(url) {
    if (WebSocketConnection._instance) {
      return WebSocketConnection._instance;
    }
    WebSocketConnection._instance = this;
    this.url = url;
    this.lastMessage = 'pong';
    this.shouldResendSubscriptions = false;
    this.subscriptions = [];
    // define a subject that will be used to send messages to the websocket
    // create a websocket subject that will handle the connection
    this.reconnect();

  }
  // every ten seconds, send a message to the server use rxjs timer
  // create a function that will reconnect to the websocket
  reconnect() {

    this.socket = webSocket({
      url: this.url,
      closeObserver: {
        next: (e) => {
          console.log('WebSocket closed',e);
        }
      },
      openObserver: {
        next: () => {
          console.log('WebSocket connected');
          if (this.shouldResendSubscriptions) {
            this.subscriptions.forEach(sub => {
              this.sendMessage(sub);
            });
            this.shouldResendSubscriptions = false;
          }
          this.startPing();
        }
      },
    });
    this.socket.pipe(
      share(),
      tap({
        error: error => {
          this.shouldResendSubscriptions = true;
          console.log(error);
          console.log('ws reconnecting...');
          
        }
      }),
      retry({count: 10,
        delay: 5000})
    ).subscribe();

  }
  // subscribe to a topic
  subscribe(topic) {
    this.subscriptions = [...this.subscriptions, { type: 'subscribe',
      channel:topic}];
    if (this.socket && !this.socket.closed) {
      this.sendMessage({ type: 'subscribe',
        channel:topic});
    }
    
  }

  // send ping
  ping() {
    this.sendMessage({ type: 'ping'});
  }

  // create timer that sends a ping every 10 seconds use rxjs timer
  startPing() {
    
  }
  
  // unsubscribe from a topic
  unsubscribe(topic) {
    this.sendMessage({ type: 'unsubscribe',
      channel:topic});
  }

  // create a function that will return an observable that will emit messages from the websocket
  getMessages() {
    return this.socket;
  }

  // create a function that will send messages to the websocket
  sendMessage(msg) {
    this.socket.next(msg);
  }
}
